import React, { useState, useContext } from "react";
import SearchField from "../SearchField/SearchField";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { useNavigate, useLocation, Outlet } from "react-router-dom";
import SocketContext from "../../contexts/SocketContext";

import "./AddCustomerModal.css";

const AddCustomerModal = ({ show, setShow, reloaddata, setReloaddata }) => {
  // General
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const location = useLocation();

  // Socket
  const { socket } = useContext(SocketContext);

  // New Customer
  const [newcustomer, setNewcustomer] = useState();

  // Search field clean up
  const [toggleSFclear, setToggleSFclear] = useState(false);

  //clean up
  const cleanNewCustomer = () => {
    setNewcustomer({});
    setToggleSFclear(!toggleSFclear);
  };

  // handle input change
  const handleInputChange = (e) => {
    setNewcustomer({ ...newcustomer, [e.target.name]: e.target.value });
  };

  // handle country select
  const handleCountrySelect = (item) => {
    setNewcustomer({ ...newcustomer, ["countryID"]: item.countryID, ["country"]: item.country });
  };
  // handle port select
  const handlePortSelect = (item) => {
    setNewcustomer({ ...newcustomer, ["PODID"]: item.PODID, ["portOfDestination"]: item.portOfDestination });
  };

  // save new customer
  const saveNewCustomer = async () => {
    try {
      const response = await axiosPrivate.post("api/customers/addnewcustomer", {
        newcustomer,
      });
      if (response.data.msg === "Saved") {
        let newcustomersocket = {
          ...newcustomer,
          ["customerID"]: response.data.customerID,
          ["region"]: response.data.region,
        };
        setShow(false);
        cleanNewCustomer();
        setReloaddata(!reloaddata);
        await socket.emit("newcustomer", newcustomersocket);
      }
    } catch (err) {
      navigate("/login", { state: { from: location }, replace: true });
    }
  };

  return (
    <div className={show ? "custommodal" : "custommodal hide"}>
      <div className='cmodal-main'>
        <div className='ac-header'>
          <h2>Add New Customer:</h2>
          <p
            onClick={(e) => {
              setShow(false);
              cleanNewCustomer();
            }}
          >
            Close
          </p>
        </div>
        <form
          className='addnewcustomer'
          onSubmit={(e) => {
            e.preventDefault();
            saveNewCustomer();
          }}
        >
          <div className='form-item'>
            <label>Company Code:</label>
            <input
              required
              name='companyCode'
              autoComplete='none'
              onChange={(e) => handleInputChange(e)}
              value={newcustomer?.companyCode || ""}
            />
          </div>
          <div className='form-item'>
            <label>Company Name:</label>
            <input
              required
              name='companyName'
              autoComplete='none'
              onChange={(e) => handleInputChange(e)}
              value={newcustomer?.companyName || ""}
            />
          </div>
          <div className='form-item'>
            <label>Address:</label>
            <textarea
              required
              name='streetAddress'
              autoComplete='none'
              onChange={(e) => handleInputChange(e)}
              value={newcustomer?.streetAddress || ""}
            />
          </div>
          <div className='form-item'>
            <label>City:</label>
            <input
              required
              name='city'
              autoComplete='none'
              onChange={(e) => handleInputChange(e)}
              value={newcustomer?.city || ""}
            />
          </div>
          <div className='form-item'>
            <label>Country:</label>
            <SearchField
              required={true}
              searchURL='api/countries/getcountries'
              value={newcustomer?.country}
              valueName='country'
              valueID='countryID'
              style={{ width: "95%" }}
              onItemSelect={handleCountrySelect}
              clearfield={toggleSFclear}
            />
          </div>
          <div className='form-item'>
            <label>Default POD:</label>
            <SearchField
              required={true}
              searchURL='api/ports/getalldisports'
              value={newcustomer?.portOfDestination}
              valueName='portOfDestination'
              valueID='PODID'
              style={{ width: "95%" }}
              onItemSelect={handlePortSelect}
              clearfield={toggleSFclear}
            />
          </div>
          <div className='form-item'>
            <label>Website:</label>
            <input
              required
              name='website'
              autoComplete='off'
              onChange={(e) => handleInputChange(e)}
              value={newcustomer?.website || ""}
            />
          </div>
          <div className='form-item'>
            <label>Notes:</label>
            <textarea
              name='notes'
              autoComplete='off'
              onChange={(e) => handleInputChange(e)}
              value={newcustomer?.notes || ""}
            />
          </div>
          <div className='form-buttons'>
            <button type='button' onClick={(e) => cleanNewCustomer()}>
              Clear
            </button>
            <button type='submit' className='mainbutton'>
              Save New
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddCustomerModal;
